<form
    name="login-form"
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
>
    <div class="form-group">
        <label>Email Address</label>
        <input
            type="email"
            formControlName="email"
            name="email"
            class="form-control"
            [ngClass]="{ 'is-invalid': loginForm.dirty && f.email.errors }"
        />
        <div
            *ngIf="loginForm.dirty && f.email.errors"
            class="invalid-feedback"
        >
            <div *ngIf="f.email.errors.required">Please enter an email.</div>
        </div>
    </div>
    <div class="form-group">
        <label>Password</label>
        <input
            type="password"
            formControlName="password"
            name="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': loginForm.dirty && f.password.errors }"
        />
        <div
            *ngIf="loginForm.dirty && f.password.errors"
            class="invalid-feedback"
        >
            <div *ngIf="f.password.errors.required">Please enter a password.</div>
        </div>
    </div>
    <div class="form-group">
        <button
            name="confirmationYesBtn"
            class="btn btn-primary"
            type="submit"
        >
            Sign In
        </button>
    </div>
    <a [routerLink]="['/account/forgot-password']">Forgot your password?</a>
</form>
<app-modal
    #activationModal
    title="Account Activation Status"
    body="Your account has not been activated. Do you want us to send you another activation email?"
    (clickPositive)="sendReactivationEmail(f.email.value)"
    isConfirm="true"
>
</app-modal>
<app-modal
    #checkEmailModal
    title="Success"
    body="An activation email has been sent to {{f.email.value}}. Please check your mailbox for further instructions."
>
</app-modal>
